import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import ss1 from "../../../assets/ss1.jpg";
import ss2 from "../../../assets/ss2.jpg";
import ss3 from "../../../assets/ss3.jpg";
import ss4 from "../../../assets/ss4.jpg";
import ss5 from "../../../assets/ss5.jpg";

const cards = [
    { id: 1, title: "Air Quality Monitoring", desc: "Precision instruments for measuring air pollution and environmental conditions.", imageUrl: ss1 },
    { id: 2, title: "Industrial Calibration", desc: "Ensuring accuracy in industrial equipment with top-notch calibration services.", imageUrl: ss2 },
    { id: 3, title: "Smart IoT Solutions", desc: "Real-time monitoring and analytics for industrial and environmental applications.", imageUrl: ss3 },
    { id: 4, title: "Research & Development", desc: "Innovative technologies for environmental analysis and smart data solutions.", imageUrl: ss4 },
    { id: 5, title: "Equipment Maintenance", desc: "Reliable servicing and maintenance for monitoring devices.", imageUrl: ss5 },
];

const GridLayout = () => {

    const { ref: titleRef, inView: titleInView } = useInView( { triggerOnce: true, threshold: 0.2 });

    const { ref: cardRef1, inView: inView1 } = useInView( { triggerOnce: true, threshold: 0.2 });

    const { ref: cardRef, inView: inView2 } = useInView( { triggerOnce: true, threshold: 0.2 });

    

    

    return (
        <div className="bg-white text-white  py-10">
            {/* Title with Scroll Animation */}
            <motion.h2
                ref={titleRef}
                className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6"
                initial={{ opacity: 0, y: 30 }}
                animate={titleInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.8, ease: "easeOut" }}
            >
                <span className="text-green-800">Innovation & Trust. </span>
                <span className="text-gray-600 font-semibold">Smart Solutions for a Sustainable Future.</span>
            </motion.h2>

            {/* Two-Column Layout */}
            <div className="flex flex-col md:flex-row gap-1 mt-12">
                {/* Left Column (Smaller Width) */}
                <div className="w-full md:w-2/5 flex flex-col gap-1">
                    {cards.slice(0, 2).map((card, index) => {

                        return (
                            <motion.div
                                ref={cardRef1}
                                key={card.id}
                                className={`bg-gray-900 bg-cover bg-center bg-no-repeat rounded-xl p-6 relative shadow-lg overflow-hidden flex flex-col justify-between 
                                    ${index === 0 ? "h-[200px] md:h-[300px]" : "h-[180px] md:h-[200px]"}
                                `}
                                style={{
                                    backgroundImage: `url(${card.imageUrl})`,
                                }}
                                initial={{ opacity: 0, x: -30 }}
                                animate={inView1 ? { opacity: 1, x: 0 } : {}}
                                transition={{ duration: 0.5, delay: index * 0.2 }}
                            >
                                {/* Dark Overlay */}
                                <div className="absolute inset-0 bg-black bg-opacity-50 rounded-xl"></div>
                                <span className="text-5xl font-bold text-gray-300 absolute top-4 left-4 z-10">0{index + 1}.</span>
                                <h3 className="text-lg font-semibold mt-auto text-white z-10">{card.title}</h3>
                                <p className="text-sm text-white z-10">{card.desc}</p>
                            </motion.div>
                        );
                    })}
                </div>

                {/* Right Column (Larger Width) */}
                <div className="w-full md:w-3/5 flex flex-col gap-1">
                    {/* First Row (One Wide Card) */}
                    <motion.div
                                                        ref={cardRef}
                                                        key={cards[2].id}
                        className="bg-gray-900 bg-cover text-white rounded-xl p-6 relative shadow-lg flex flex-col justify-between h-[220px]"
                        style={{
                            backgroundImage: `url(${cards[2].imageUrl})`,
                        }}
                        initial={{ opacity: 0, y: 30 }}
                        animate={inView2 ? { opacity: 1, y: 0 } : {}}
                        transition={{ duration: 0.5, delay: cards.indexOf(cards[2].id) * 0.2 }}
                    >
                        <div className="absolute inset-0 bg-black bg-opacity-50 rounded-xl"></div>
                        <span className="text-5xl font-bold text-gray-300 absolute top-4 left-4">03.</span>
                        <h3 className="text-lg font-semibold mt-auto text-white z-10">{cards[2].title}</h3>
                        <p className="text-sm text-white z-10">{cards[2].desc}</p>
                    </motion.div>

                    {/* Second Row (Two Cards) */}
                    <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-1">
                        {cards.slice(3, 5).map((card, index) => {

                            return (
                                <motion.div
                                    ref={cardRef}
                                    key={card.id}
                                    className={`bg-gray-900 bg-cover rounded-xl p-6 relative shadow-lg overflow-hidden flex flex-col justify-between h-[200px] md:h-[280px]`}
                                    style={{
                                        backgroundImage: `url(${card.imageUrl})`,
                                    }}
                                    initial={{ opacity: 0, y: 30 }}
                                    animate={inView2 ? { opacity: 1, y: 0 } : {}}
                                    transition={{ duration: 0.5, delay: index * 0.2 }}
                                >
                                    <div className="absolute inset-0 bg-black bg-opacity-50 rounded-xl"></div>
                                    <span className="text-5xl font-bold text-gray-300 absolute top-4 left-4">0{index + 4}.</span>
                                    <h3 className="text-lg font-semibold mt-auto text-white z-10">{card.title}</h3>
                                    <p className="text-sm text-white z-10">{card.desc}</p>
                                </motion.div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GridLayout;
